<template>
  <div id="banner">
    <parallax :fixed="true" :sectionClass="'parallax-container'">
      <div class="banner__img" :style="{ backgroundImage: 'url(' + bannerUrl + ')' }">
        <!-- <div class="banner__title">Churrasco</div>
        <div class="banner__place"><i class="icon-place"></i> 856 Esta Underpass</div> -->
      </div>
    </parallax>
  </div>
</template>

<script>
  import Parallax from 'vue-parallaxy'
  export default {
    components: { Parallax },
    props: {
      bannerUrl: {
        type: String,
        default: () => ''
      }
    },
    methods: {
      onLoad() {
        //document.getElementsByClassName('parallax-container')[0].style.height = this.$refs.bannerImage.clientHeight + 'px';
        this.$emit('image-loaded')
      }
    }
  }
</script>
